import { render } from "./HowtovoteEng.vue?vue&type=template&id=32420594&scoped=true"
import script from "./HowtovoteEng.vue?vue&type=script&lang=js"
export * from "./HowtovoteEng.vue?vue&type=script&lang=js"

import "./HowtovoteEng.vue?vue&type=style&index=0&id=32420594&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32420594"]])

export default __exports__